(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aa-free-shipping-progress"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.aaFreeShippingProgress) return;

  function formatMoney(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cents, format); } catch (e) {}
    }
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    var locale = document.documentElement.lang || undefined;
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function render(totalCents) {
    var rate = parseFloat((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1) || 1;
    document.querySelectorAll('[data-aa-fsp]').forEach(function (el) {
      var threshold = Math.round((parseInt(el.dataset.threshold, 10) || 0) * rate);
      var left = threshold - totalCents;
      var done = threshold <= 0 || left <= 0;
      var percent = done ? 100 : Math.max(0, Math.min(100, Math.round((totalCents / threshold) * 100)));
      var msg = el.querySelector('[data-aa-fsp-message]');
      var bar = el.querySelector('[data-aa-fsp-bar]');
      var track = el.querySelector('[data-aa-fsp-track]');

      el.classList.toggle('is-unlocked', done);
      if (msg) {
        if (done) {
          msg.textContent = el.dataset.textUnlocked;
        } else {
          var amount = formatMoney(left, el.dataset.moneyFormat);
          var parts = el.dataset.textRemaining.split('{amount}');
          msg.textContent = '';
          parts.forEach(function (part, i) {
            msg.appendChild(document.createTextNode(part));
            if (i < parts.length - 1) {
              var strong = document.createElement('strong');
              strong.textContent = amount;
              msg.appendChild(strong);
            }
          });
        }
      }
      if (bar) bar.style.width = percent + '%';
      if (track) track.setAttribute('aria-valuenow', percent);
    });
  }

  function refresh() {
    if (!document.querySelector('[data-aa-fsp]')) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart.total_price || 0); })
      .catch(function () {});
  }

  // Re-check after any cart change made through the Ajax Cart API, whatever the theme uses to call it.
  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function () {
      var url = arguments[0] && (arguments[0].url || arguments[0]);
      var p = origFetch.apply(this, arguments);
      if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
        p.then(function () { setTimeout(refresh, 50); }).catch(function () {});
      }
      return p;
    };
  }
  ['cart:updated', 'cart:refresh', 'cart:change', 'cart-drawer:open'].forEach(function (evt) {
    document.addEventListener(evt, refresh);
  });
  document.addEventListener('shopify:section:load', refresh);

  window.aaFreeShippingProgress = { refresh: refresh };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
})();
  } catch(e) { console.error(e); }
})();

})();
